import { useState, type ReactNode } from 'react';
import { Tooltip } from '@odo/shared-ui';
import { useIsTextTruncated } from '../../../../../hooks/useIsTextTruncated';
import { TOOLTIP_OVER_MODAL } from './DmControlPrimitives';

interface FactProps {
    label: string;
    children: ReactNode;
    fullText?: string | null;
    /** Beside the label, e.g. an edit button revealed on hover. */
    action?: ReactNode;
}

export function Fact({ label, children, fullText, action }: FactProps) {
    const [element, setElement] = useState<HTMLElement | null>(null);
    const truncated = useIsTextTruncated(element, fullText ?? '');
    return (
        <div className="group min-w-0 flex-1">
            <dt className="flex items-center gap-1 text-xs text-gray-500">
                {label}
                {action}
            </dt>
            <Tooltip content={fullText} className={TOOLTIP_OVER_MODAL} disabled={!truncated}>
                <dd
                    ref={setElement}
                    className="mt-0.5 truncate text-[13px] font-medium text-gray-800"
                >
                    {children}
                </dd>
            </Tooltip>
        </div>
    );
}

export function Muted({ children }: { children: ReactNode }) {
    return <span className="font-normal text-gray-400">{children}</span>;
}
